export enum NonCompetitionRestrictionSlot {
    DistanceRadiusMiles = 0,
    DurationMonthsFromClosing = 1,
    DurationMonthsFromEmployment = 2,
}

export const NonCompetitionRestrictionSlotLabels: Record<NonCompetitionRestrictionSlot, string> = {
    [NonCompetitionRestrictionSlot.DistanceRadiusMiles]: 'Distance: Radius (miles)',
    [NonCompetitionRestrictionSlot.DurationMonthsFromClosing]: 'Duration: Months from Closing',
    [NonCompetitionRestrictionSlot.DurationMonthsFromEmployment]: 'Duration: Months from Employment',
};

export const NonCompetitionRestrictionSlotOptions: { value: NonCompetitionRestrictionSlot; label: string }[] = [
    { value: NonCompetitionRestrictionSlot.DistanceRadiusMiles, label: NonCompetitionRestrictionSlotLabels[NonCompetitionRestrictionSlot.DistanceRadiusMiles] },
    { value: NonCompetitionRestrictionSlot.DurationMonthsFromClosing, label: NonCompetitionRestrictionSlotLabels[NonCompetitionRestrictionSlot.DurationMonthsFromClosing] },
    { value: NonCompetitionRestrictionSlot.DurationMonthsFromEmployment, label: NonCompetitionRestrictionSlotLabels[NonCompetitionRestrictionSlot.DurationMonthsFromEmployment] },
];
